export const RENAME_AUTOMATON_MODAL = 'RENAME_AUTOMATON_MODAL';
export const STATES_MODAL = 'STATES_MODAL';
export const TAPE_ALPHABET_MODAL = 'TAPE_ALPHABET_MODAL';
export const BLANK_SYMBOL_MODAL = 'BLANK_SYMBOL_MODAL';
export const INPUT_ALPHABET_MODAL = 'INPUT_ALPHABET_MODAL';
export const STACK_ALPHABET_MODAL = 'STACK_ALPHABET_MODAL';
export const FSM_TRANSITION_MODAL = 'FSM_TRANSITION_MODAL';
export const PDA_TRANSITION_MODAL = 'PDA_TRANSITION_MODAL';
export const TM_TRANSITION_MODAL = 'TM_TRANSITION_MODAL';
export const DELETE_TRANSITION_MODAL = 'DELETE_TRANSITION_MODAL';
export const TEST_CASE_MODAL = 'TEST_CASE_MODAL';
export const DELETE_TEST_CASE_MODAL = 'DELETE_TEST_CASE_MODAL';
export const INITIAL_STACK_SYMBOL_MODAL = 'INITIAL_STACK_SYMBOL_MODAL';
export const INITIAL_STATE_MODAL = 'INITIAL_STATE_MODAL';
export const ACCEPT_STATES_MODAL = 'ACCEPT_STATES_MODAL';
export const RENAME_STATE_MODAL = 'RENAME_STATE_MODAL';


// WEBPACK FOOTER //
// ./src/constants/modalTypes.js